/**
 * @module SortByPanel/DatasetFieldSort/DatasetFieldOptionText
 * @description 字段下拉选项展示：类型图标 + 字段名（对齐 FilterColumn，不拼图表名）
 */

import React from 'react';
import { FieldTypeIcon, type TFieldType } from '@dbl/core/dataSource';
import SvgIcon from '@home/components/SvgIcon';

export interface IDatasetFieldOptionTextProps {
  displayName: string;
  columnType?: string;
}

const DatasetFieldOptionText: React.FC<IDatasetFieldOptionTextProps> = ({
  displayName,
  columnType,
}) => {
  const iconType = FieldTypeIcon[(columnType || '') as TFieldType] || 'abc';

  return (
    <div
      title={displayName}
      className="dbl-chart-dataset-field-sort__option"
    >
      <SvgIcon className={iconType} type={iconType} />
      <span className="dbl-chart-dataset-field-sort__option-text">
        {displayName}
      </span>
    </div>
  );
};

export default React.memo(DatasetFieldOptionText);
